import { createDemoStore } from '@/demo/core/create-demo-store';
import type { RiskState } from './risk-types';

function buildSeed(): RiskState {
  return { actions: {}, acknowledged: {}, resolved: {} };
}

export const riskStore = createDemoStore<RiskState>(buildSeed);

export function startRiskAction(actionId: string): void {
  riskStore.update((draft) => {
    draft.actions[actionId] = 'running';
  });
}

export function completeRiskAction(actionId: string): void {
  riskStore.update((draft) => {
    draft.actions[actionId] = 'done';
  });
}

export function acknowledgeRiskAlert(alertId: string): void {
  riskStore.update((draft) => {
    draft.acknowledged[alertId] = true;
  });
}

export function resolveRiskAlert(alertId: string): void {
  riskStore.update((draft) => {
    draft.resolved[alertId] = true;
  });
}

/** Clears every action, acknowledgement and resolution back to the seed. */
export function resetRiskDemo(): void {
  riskStore.reset();
}
